/**
 * Triggers a browser download for a file at the given URL.
 *
 * @param url - The URL of the file to download (absolute or relative to the public root).
 * @param fileName - The name to save the file as on the user's device.
 */
export function downloadFile(url: string, fileName: string): void {
  const anchor = document.createElement('a');
  anchor.href = url;
  anchor.download = fileName;
  document.body.appendChild(anchor);
  anchor.click();
  anchor.remove();
}
